module.exports = __webpack_public_path__ + "img/promo-credit.35e24867.svg";